(function () {
	// console.log('dgvs_theme js')
})();
